import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const submitContact = (data) => axios.post(`${API}/contact`, data);
export const submitQuote = (data) => axios.post(`${API}/quote`, data);
export const submitBooking = (data) => axios.post(`${API}/booking`, data);
export const sendChatMessage = (session_id, message) =>
  axios.post(`${API}/chat`, { session_id, message });

export function getChatSessionId() {
  let id = localStorage.getItem('xpert_chat_session');
  if (!id) {
    id = 'sess_' + Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem('xpert_chat_session', id);
  }
  return id;
}
